import AppBar from "@mui/material/AppBar";
import Drawer from "@mui/material/Drawer";
import Hidden from "@mui/material/Hidden";
import IconButton from "@mui/material/IconButton";
// @material-ui/core components
import { makeStyles } from "tss-react/mui";
import Toolbar from "@mui/material/Toolbar";
import Close from "@mui/icons-material/Close";
// @mui/icons-material
import Menu from "@mui/icons-material/Menu";
// core components
import styles from "assets/jss/xrs/components/headerStyle.js";
// nodejs library that concatenates classes
// nodejs library to set properties for components
import PropTypes from "prop-types";
import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

const useStyles = makeStyles()((theme) => styles(theme));

export default function Header(props) {
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const { classes, cx } = useStyles();
  const logo = useSelector((state) => state.GetSiteDetailsReducer.logoimageurl);

  React.useEffect(() => {
    if (props.changeColorOnScroll) {
      window.addEventListener("scroll", headerColorChange);
    }
    return function cleanup() {
      if (props.changeColorOnScroll) {
        window.removeEventListener("scroll", headerColorChange);
      }
    };
  });

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const headerColorChange = () => {
    const { color, changeColorOnScroll } = props;

    const windowsScrollTop = window.pageYOffset;
    if (windowsScrollTop > changeColorOnScroll.height) {
      document.body
        .getElementsByTagName("header")[0]
        .classList.remove(classes[color]);
      document.body
        .getElementsByTagName("header")[0]
        .classList.add(classes[changeColorOnScroll.color]);
    } else {
      document.body
        .getElementsByTagName("header")[0]
        .classList.add(classes[color]);
      document.body
        .getElementsByTagName("header")[0]
        .classList.remove(classes[changeColorOnScroll.color]);
    }
  };
  const { color, links, fixed, absolute } = props;
  const appBarClasses = cx(
    classes.appBar, // Always include this class
    color === "white" && classes.white, // Conditionally include classes.white if color is "white"
    absolute && classes.absolute, // Conditionally include classes.absolute if absolute is true
    fixed && classes.fixed, // Conditionally include classes.fixed if fixed is true
    classes.border // Conditionally include classes.border if border is 0
  );
  return (
    <AppBar className={appBarClasses}>
      <Toolbar className={classes.container}>
        <Hidden smDown implementation="css" className={classes.hidden}>
          <Link to="/landing-page">
            {logo === "" ? null : (
              <img src={logo} height="60px" alt="..." className={classes.img} />
            )}
          </Link>
        </Hidden>
        <Hidden smDown implementation="css" className={classes.hidden}>
          <div className={cx(classes.collapse, classes.appResponsiveRight)}>
            {links}
          </div>
        </Hidden>
        <Hidden mdUp>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerToggle}
          >
            <Menu />
          </IconButton>
        </Hidden>
        <Hidden mdUp>
          <Link to="/landing-page">
            {logo === "" ? null : (
              <img src={logo} height="45px" alt="..." className={classes.img} />
            )}
          </Link>
        </Hidden>
      </Toolbar>
      <Hidden mdUp implementation="js">
        <Drawer
          variant="temporary"
          anchor={"right"}
          open={mobileOpen}
          classes={{
            paper: classes.drawerPaper,
          }}
          onClose={handleDrawerToggle}
        >
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerToggle}
            className={classes.closeButtonDrawer}
          >
            <Close />
          </IconButton>
          <div className={cx(classes.appResponsive)}>{links}</div>
        </Drawer>
      </Hidden>
    </AppBar>
  );
}

Header.defaultProp = {
  color: "white",
};

Header.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "info",
    "success",
    "warning",
    "danger",
    "transparent",
    "white",
    "rose",
    "dark",
  ]),
  links: PropTypes.node,
  brand: PropTypes.string,
  fixed: PropTypes.bool,
  absolute: PropTypes.bool,
  // this will cause the sidebar to change the color from
  // props.color (see above) to changeColorOnScroll.color
  // when the window.pageYOffset is heigher or equal to
  // changeColorOnScroll.height and then when it is smaller than
  // changeColorOnScroll.height change it back to
  // props.color (see above)
  changeColorOnScroll: PropTypes.shape({
    height: PropTypes.number.isRequired,
    color: PropTypes.oneOf([
      "primary",
      "info",
      "success",
      "warning",
      "danger",
      "transparent",
      "white",
      "rose",
      "dark",
    ]).isRequired,
  }),
};
